import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { LucideAngularModule, icons } from 'lucide-angular';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { InfoService } from './core/services/info.service';

function initInfoFactory() {
  const infoService = inject(InfoService);
  return () => infoService.initialize();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
          cssLayer: false,
          primary: {
            50: '#d6ddd5',
            100: '#bbc6b9',
            200: '#a0af9d',
            300: '#859881',
            400: '#6b7e67',
            500: '#536250',
            600: '#3b4639',
            700: '#242a22',
            800: '#242a22',
            900: '#242a22',
          },
        },
      },
    }),
    ...(LucideAngularModule.pick(icons).providers || []),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: initInfoFactory,
    },
  ],
};
